<template>
  <div class="training-time-table">
    <p class="title">리틀드래곤즈<span>클래스</span></p>

    <div class="time-table-layout">
      <table class="time-table">
        <thead>
        <tr>
          <td rowspan="3">시간</td>
          <td colspan="4">클래스</td>
        </tr>
        <tr>
          <td colspan="2">토요일</td>
          <td colspan="2">일요일</td>
        </tr>
        <tr>
          <td>1구장</td>
          <td>2구장</td>
          <td>1구장</td>
          <td>2구장</td>
        </tr>
        </thead>
        <tbody>
        <tr>
          <td>09:00 ~ 10:00</td>
          <td>유치부(토)</td>
          <td>1학년(토)</td>
          <td>유치부(일)</td>
          <td>1학년(일)</td>
        </tr>
        <tr>
          <td>10:00 ~ 11:00</td>
          <td>2학년(토)</td>
          <td>3학년(토)</td>
          <td>2학년(일)</td>
          <td>5, 6학년(일)</td>
        </tr>
        <tr>
          <td>11:00 ~ 12:00</td>
          <td>4학년(토)</td>
          <td>5, 6학년(토)</td>
          <td>3학년(육성반)</td>
          <td>4학년(육성반)</td>
        </tr>
        </tbody>
      </table>
    </div>

    <p class="title">리틀드래곤즈 팀(TEAM)<span>클래스</span></p>

    <div class="time-table-layout">
      <table class="time-table">
        <thead>
        <tr>
          <td rowspan="3">시간</td>
          <td colspan="4">클래스</td>
        </tr>
        <tr>
          <td colspan="2">토요일</td>
          <td colspan="2">일요일</td>
        </tr>
        <tr>
          <td>1구장</td>
          <td>2구장</td>
          <td>1구장</td>
          <td>2구장</td>
        </tr>
        </thead>
        <tbody>
        <tr>
          <td>13:00 ~ 14:00</td>
          <td>TEAM 1</td>
          <td>TEAM 2</td>
          <td>TEAM 5</td>
          <td>TEAM 6</td>
        </tr>
        <tr>
          <td>14:00 ~ 15:00</td>
          <td>TEAM 3</td>
          <td>TEAM 4</td>
          <td>TEAM 7</td>
          <td>TEAM 8</td>
        </tr>
        </tbody>
      </table>
    </div>
    <p>※ 각 연령별 모집완료 순서에 따라 TEAM1 시간대부터 선착순 배정 됩니다.(확정 시 개별안내)</p>
    <!--
    <table class="time-table">
      <caption>토요일반</caption>
      <thead>
        <tr>
          <td v-for="(item, index) in theadList" :key="index">{{item}}</td>
        </tr>
      </thead>
      <tbody v-for="(item, index) in saturdaySchedule" :key="index">
        <tr v-for="(tdItem, tdIndex) in item.children" :key="tdIndex">
          <td v-if="tdIndex === 0" :rowspan="item.children.length">{{item.time}}</td>
          <td>{{tdItem.class}}</td>
          <td v-if="tdIndex === 0" :rowspan="item.children.length">{{tdItem.person}}</td>
        </tr>
      </tbody>
    </table>

    <table class="time-table">
      <caption>일요일반</caption>
      <thead>
      <tr>
        <td v-for="(item, index) in theadList" :key="index">{{item}}</td>
      </tr>
      </thead>
      <tbody v-for="(item, index) in sundaySchedule" :key="index">
      <tr v-for="(tdItem, tdIndex) in item.children" :key="tdIndex">
        <td v-if="tdIndex === 0" :rowspan="item.children.length">{{item.time}}</td>
        <td>{{tdItem.class}}</td>
        <td v-if="tdIndex === 0" :rowspan="item.children.length">{{tdItem.person}}</td>
      </tr>
      </tbody>
    </table>
    -->
  </div>
</template>

<script>
export default {
  name: 'TrainingTimetable',
  props: ['routeName'],
  data() {
    return {
      theadList: ['일시', '클래스', '정원'],
      saturdaySchedule: [],
      sundaySchedule: [],
    }
  },
  mounted () {
    this.getTrainingTime()
  },
  methods: {
    getTrainingTime() {
      this.saturdaySchedule = [
        {
          time: '09:00 ~ 10:00',
          children: [
            {
              class: '유치부(토)',
              person: '클래스 당 20명'
            }, {
              class: '1학년(토)',
              person: '클래스 당 20명'
            }
          ]
        }, {
          time: '10:00 ~ 11:00',
          children: [
            {
              class: '2학년(토)',
              person: '클래스 당 20명'
            }, {
              class: '3학년(토)',
              person: '클래스 당 20명'
            }
          ]
        }, {
          time: '11:00 ~ 12:00',
          children: [
            {
              class: '4학년(토)',
              person: '클래스 당 20명'
            }, {
              class: '5, 6학년(토)',
              person: '클래스 당 20명'
            }
          ]
        }
      ];

      this.sundaySchedule = [
        {
          time: '09:00 ~ 10:00',
          children: [
            {
              class: '유치부(일)',
              person: '클래스 당 20명'
            }, {
              class: '1학년(일)',
              person: '클래스 당 20명'
            }
          ]
        }, {
          time: '10:00 ~ 11:00',
          children: [
            {
              class: '2학년(일)',
              person: '클래스 당 20명'
            }, {
              class: '5, 6학년(일)',
              person: '클래스 당 20명'
            }
          ]
        }, {
          time: '11:00 ~ 12:00',
          children: [
            {
              class: '3학년(육성반)',
              person: '클래스 당 20명'
            }, {
              class: '4학년(육성반)',
              person: '클래스 당 20명'
            }
          ]
        }
      ];
    }
  }
}
</script>
<style lang="scss" scoped>
.time-table-layout {
  table {
    min-width: 800px !important;
  }
  overflow: auto;
  &::-webkit-scrollbar {
    width: 20px;
    height: 6px;
  }
  &::-webkit-scrollbar-track {
    box-shadow: inset 0 0 10px 10px #F9F9F9;
    border-radius: 10px;
    //border: solid 6px transparent;
  }
  &::-webkit-scrollbar-thumb {
    box-shadow: inset 0 0 10px 10px #AFAFAF;
    border-radius: 10px;
    //border: solid 6px transparent;
  }
  &::-webkit-scrollbar-button:horizontal:single-button:end {
    position: absolute;
    overflow: hidden;
    content: '';
    width: 35px;
  }
  &::-webkit-scrollbar-track:vertical {
    background-clip: padding-box;
    border: 7px solid transparent;
  }
  &::-webkit-scrollbar-thumb:vertical {
    background-clip: padding-box;
    border: 7px solid transparent;
  }
  table {
    min-width: 1200px;
    margin-bottom: 12px;
    /* 행 고정 시 border 투명화 현상 방지 */
    border-collapse: separate;
    border-spacing: 0;
    thead {
      tr {
        td {
          padding: 10px 0;
        }
      }
    }
    tbody {
      tr:first-child {
        td:first-child {
          border-right: 0;
        }
      }
      td {
        border-left: 1px solid #E5E5E5;
      }
      td:first-child {
        border-left: 0;
      }
    }
  }
}
</style>
